import { createAsyncReducer } from '../../standard-actions/reducers';
import {
    ILoadOrderInfoAction,
    IOrderInfoResetAction,
    ILoadOrderInfoSuccessAction,
    LoadOrderInfoErrorAction,
    IUpdateSelectedProductSuccessAction,
    IUpdateSelectedProductTempSuccessAction,
    IDetailUpdateViewBySuccessAction,
} from '../actions/load-order-info';
import { groupAndSortSummary } from '../methods/group-and-sort-summary-details';
import { IOrderTrackerState } from '../state';
import { initialState } from '../state/initial-state';
import { defaultInitialState } from '../state/order-info';

export type LoadOrderInfoAction
    = ILoadOrderInfoAction
    | ILoadOrderInfoSuccessAction
    | LoadOrderInfoErrorAction;

export type UpdateSelectedProductAction = IUpdateSelectedProductSuccessAction;
export type UpdateSelectedProductTempAction = IUpdateSelectedProductTempSuccessAction;

export type DetailUpdateViewBySuccessAction = IDetailUpdateViewBySuccessAction;
export type OrderInfoResetAction = IOrderInfoResetAction;

export const resetOrderInfoReducer = (state: IOrderTrackerState, action: IOrderInfoResetAction) => ({
    ...state,
    orderInfo: {
        ...state.orderInfo,
        status: action.status,
        data: {
            ...defaultInitialState,
            originalData: defaultInitialState,
            selectedViewBy: ''
        }
    }
});

const init = (state: IOrderTrackerState, action: LoadOrderInfoAction) => ({
    ...state,
    orderInfo: {
        ...state.orderInfo,
        status: action.status,
        data: {
            ...state.orderInfo.data,
            ...defaultInitialState,
            originalData: defaultInitialState,
            selectedViewBy: ''
        }
    }
});

const success = (state: IOrderTrackerState, action: LoadOrderInfoAction) => {
    const summary = (action as ILoadOrderInfoSuccessAction).data.summary;
    const calculatedSummary = groupAndSortSummary(summary);

    const productName = state.orderInfo.temp && state.orderInfo.temp.productName;
    const productType = state.orderInfo.temp && state.orderInfo.temp.productType;
    const siteAddress = state.orderInfo.temp && state.orderInfo.temp.siteAddress;

    const progress = (action as ILoadOrderInfoSuccessAction).data.progress;
    const selectedProductonListPage = progress.filter((item) =>
        item.name.toLowerCase() === productName.toLowerCase() &&
        item.type === productType &&
        item.location === siteAddress
    )

    let selectedSummaryItem = Object.keys(calculatedSummary)[0];
    let selectedProduct = calculatedSummary[selectedSummaryItem]
    [Object.keys(calculatedSummary[selectedSummaryItem])[0]][0].uuid;

    if (selectedProductonListPage.length) {
        // tslint:disable-next-line:forin
        for (const tempLocation in calculatedSummary) {
            // tslint:disable-next-line:forin
            for (const tempSubLocation in calculatedSummary[tempLocation]) {
                calculatedSummary[tempLocation][tempSubLocation].forEach((val) => {
                    if (val.uuid === selectedProductonListPage[0].uuid) {
                        selectedSummaryItem = tempLocation;
                        selectedProduct = val.uuid;
                    }
                });
            }
        }
    }

    const orderInfo = {
        status: (action as ILoadOrderInfoSuccessAction).data.status,
        amendStatus: (action as ILoadOrderInfoSuccessAction).data.amendStatus,
        orderClosedDate: (action as ILoadOrderInfoSuccessAction).data.orderClosedDate || '',
        estimatedDate: (action as ILoadOrderInfoSuccessAction).data.estimatedDate,
        requiredDate: (action as ILoadOrderInfoSuccessAction).data.requiredDate,
        ncp: (action as ILoadOrderInfoSuccessAction).data.ncp,
        selectedProduct,
        selectedSummaryItem,
        summary,
        calculatedSummary,
        progress: (action as ILoadOrderInfoSuccessAction).data.progress,
        substageContent: (action as ILoadOrderInfoSuccessAction).data.substageContent,
        emptySubstageContent: (action as ILoadOrderInfoSuccessAction).data.emptySubstageContent,
        substageCommentsContent: (action as ILoadOrderInfoSuccessAction).data.substageCommentsContent,
        projectManager: (action as ILoadOrderInfoSuccessAction).data.projectManager,
        yourReference: (action as ILoadOrderInfoSuccessAction).data.yourReference,
        customerName: (action as ILoadOrderInfoSuccessAction).data.customerName,
        primaryContact: (action as ILoadOrderInfoSuccessAction).data.primaryContact,
        contractSignedDate: (action as ILoadOrderInfoSuccessAction).data.contractSignedDate,
        referenceOrders: (action as ILoadOrderInfoSuccessAction).data.referenceOrders,
        fulfilmentVersion: (action as ILoadOrderInfoSuccessAction).data.fulfilmentVersion,
        suspendResumeContent: (action as ILoadOrderInfoSuccessAction).data.suspendResumeContent,
        relatedRequestNumber: (action as ILoadOrderInfoSuccessAction).data.relatedRequestNumber,
        customerAcceptance: (action as ILoadOrderInfoSuccessAction).data.customerAcceptance,
        submittedToSDDate: (action as ILoadOrderInfoSuccessAction).data.submittedToSDDate,
        rootProductType: (action as ILoadOrderInfoSuccessAction).data.rootProductType,
        solutionOrderType: (action as ILoadOrderInfoSuccessAction).data.solutionOrderType,
        flowType: (action as ILoadOrderInfoSuccessAction).data.flowType,
    }

    return ({
        ...state,
        orderInfo: {
            ...state.orderInfo,
            status: action.status,
            data: {
                ...state.orderInfo.data,
                ...orderInfo,
                originalData: { ...orderInfo }
            },
            temp: {
                productName: '',
                productType: '',
                siteAddress: ''
            }
        }
    })
};

const failure = (state: IOrderTrackerState, action: LoadOrderInfoAction) => ({
    ...state,
    orderInfo: {
        ...initialState.orderInfo,
        status: action.status,
        error: (action as LoadOrderInfoErrorAction).error
    }
});

export const loadOrderInfoReducer = createAsyncReducer(initialState, init, success, failure);

export const updateSelectedProductReducer =
    (state: IOrderTrackerState, action: IUpdateSelectedProductSuccessAction) => {
        return ({
            ...state,
            orderInfo: {
                ...state.orderInfo,
                data: {
                    ...state.orderInfo.data,
                    selectedProduct: action.product,
                    selectedSummaryItem: action.summaryItem
                }
            }
        })
    }

export const updateDetailsViewByReducer = (state: IOrderTrackerState, action: IDetailUpdateViewBySuccessAction) => {
    const summary = state.orderInfo.data.summary;
    const calculatedSummary = groupAndSortSummary(summary, action.viewby);
    const selectedSummaryItem = Object.keys(calculatedSummary)[0];
    const selectedProduct = calculatedSummary[selectedSummaryItem]
    [Object.keys(calculatedSummary[selectedSummaryItem])[0]][0].uuid;

    return ({
        ...state,
        orderInfo: {
            ...state.orderInfo,
            data: {
                ...state.orderInfo.data,
                selectedViewBy: action.viewby,
                selectedProduct,
                selectedSummaryItem,
                calculatedSummary
            }
        }
    })
}

export const updateSelectedProductTempReducer = (state: IOrderTrackerState,
    action: IUpdateSelectedProductTempSuccessAction) => {

    return ({
        ...state,
        orderInfo: {
            ...state.orderInfo,
            temp: {
                productName: (action as IUpdateSelectedProductTempSuccessAction).productName,
                productType: (action as IUpdateSelectedProductTempSuccessAction).productType,
                siteAddress: (action as IUpdateSelectedProductTempSuccessAction).siteAddress
            }
        }
    })
}
